/* globals route */
/* eslint-disable no-unused-vars */

import Vue from 'vue';
import Inactivity from './core/Inactivity';
import './bootstrap';
import './components';
import './plugins';
import './events';

/**
 * Init Vue.
 */
const app = new Vue({
  el: '#app',

  mounted() {
    Event.listen('flash', options => this.$notify(options));

    // Emit global onpostate event due to an issue with multiple onpostate events not firing.
    window.onpopstate = () => Event.fire('onpopstate');
  },
});

/**
 * Init Inactivity.
 */
Inactivity.wait('20 minutes').then(() => {
  if (!route().current('lock') && !route().current('login.show')) {
    window.location.assign(route('lock'));
  }
});
